import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

export const useBreakPoint = () => {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

  useEffect(() => {
    const handleResize = () => setSize([window.innerWidth, window.innerHeight]);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    size: size,
    isMobile: size[0] <= MOBILE_BREAKPOINT
  };
};
